import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { getLogger } from 'tofe-core';
import { merge } from 'ts-deepmerge';

import { DefaultCustomization } from './customization.constants';
import { TofeCustomization } from './models/tofe-customization.model';

const logger = getLogger('[Service][CustomizationLoader]');

@Injectable({
  providedIn: 'root',
})
export class CustomizationLoaderService {
  private readonly http = inject(HttpClient);

  getCustomization(name: string): Observable<TofeCustomization> {
    if (name === 'default') return of(DefaultCustomization);
    return this.http.get<TofeCustomization>(`assets/customizations/${name}.json`).pipe(
      map((x) => merge(DefaultCustomization, x)),
      catchError((err) => {
        logger.error(`current$ http error`, err);
        return of(DefaultCustomization);
      }),
    );
  }
}
